import { gql } from "@apollo/client";

export const NEW_LIKE_FRAGMENT = gql`
  fragment NewLike on Like {
    id
    userId
    storeId
    createdAt
  }
`;
